module.exports = __webpack_public_path__ + "img/seating_keyboard.165113e5.png";